import styled, { keyframes } from "styled-components";

const translate = keyframes`
0% {
    opacity: 0;
    transform: translateY(40px);
}
100% {
    opacity: 1;
    transform: translateY(0);
}
`;

export const ToastContainer = styled.div`
  position: fixed;
  bottom: 80px;
  right: 32px;
  z-index: 100000;

  .triangle {
    display: none;
  }
  .toast {
    animation: ${translate} 0.5s;
    width: 246px;
    height: 52px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background-color: ${props => props.theme.backgroundDark};
    border: ${props =>
      `${props.theme.border.standard} solid ${props.theme.border.color}`};
    cursor: pointer;

    p {
      font-size: ${props => props.theme.p2r.fs};
    }
  }
`;
export const Icon = styled.img`
  justify-self: end;
  transform: rotate(90deg);
`;
